import { Camelizer } from '../utils';
import BaseAPI from './BaseAPI';

export default class PatientContextAPI extends BaseAPI {
  async search({
    orgId,
    query,
    from,
    pageSize,
  }: {
    orgId: string;
    query: string;
    from: number;
    pageSize: number;
  }) {
    const res = await this.httpClient.post(
      `${this.host.tcUrl}/v1/patient-search-service/api/search/patient`,
      {
        headers: { 'TT-X-Organization-Key': orgId },
        withCredentials: false,
        data: {
          // temp workaround until server implements AND by default
          // https://tigertext.atlassian.net/browse/TV-312
          query: `*${query.split(' ').join(' AND ')}*`,
          from,
          pageSize,
        },
      }
    );

    return Camelizer.camelizeObject(res.data);
  }

  async getPatient({ patientContextId, orgId }: { patientContextId: string; orgId: string }) {
    const res = await this.httpClient.get(
      `${this.host.tcUrl}/v1/patient-service/api/patients/${patientContextId}`,
      {
        withCredentials: false,
        headers: { 'TT-X-Organization-Key': orgId },
      }
    );

    return Camelizer.camelizeObject(res.data);
  }
}
